import React, { useState, useEffect } from 'react';
import { Modal, Button, Row, Col, Form, Container } from 'react-bootstrap';
import POServices from '../../../services/PoServices';
import RepairPoServices from '../../../services/RepairPoServices';
import Swal from 'sweetalert2';

const PoMakingModal = ({ show, handleClose, test, items }) => {
    console.log("pomaking", items)

    const [itemList, setItemList] = useState([]);
    const [selectedItems, setSelectedItems] = useState({});
    const [suppliers, setSuppliers] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [loading, setLoading] = useState(false);
    const [subject, setSubject] = useState('');
    const [reference, setReference] = useState(
        'With reference to our discussion and negotiation, we wish to place the Purchase Order for the following items:'
    );
    const [termConditionText, setTermConditionText] = useState(`1. Delivery:- 19.07.2025
2. Brand & Specification - The material will not be received or will be rejected in case the material brand/specification/length as per order are changed & MTC not provided.
3. Transportation - Freight Extra as per actual.
4. Refund / Replace - Should be of good quality and if not found satisfactory shall be returned back and replacement/refund to be provided by you within 3 days.
5. Invoice Submission - A) One Copy with Eway Bill sent to the Shipping address.
6. Invoice Submission - B) Original Invoice along with Ewaybill to be sent to our head office: 3rd floor, plot # 12/b, pocket 3, sec-17, Dwarka, New Delhi - 110075.
7. Payment Terms - 100% Advance.
8. Payment Terms - 30 Days PDC against date of delivery at site.
9. Payment Terms - 15 Days PDC after the delivery of material.
10. All concrete will be supplied as per the approved Design Mix and consistency checked at site by our client.
11. Weight bridge receipts are to be produced full and empty transit mixer at designated weight bridge centre (your cooperation as & when required for volume verification).
12. PRISM JOHNSON LIMITED will be responsible for the performance and strength of M-30.
13. All raw material like Cement OPC, Aggregate, Sand, Admixture will be of approved quality by us & our client and as per approved Mix Design. Royalty paid challan copies to be provided for compliance record keeping.
14. No escalation to be payable for any account. Rates are valid for 6 months project time.
15. Payment Terms - Payment will be released within 30 days after submission of 15 days bill with all documents duly approved by our site in-charge.
16. Material test certificate to be provided by you at the time of material delivery.
17. MTC of the cover block from manufacturer to be issued to us immediately along with delivery with signed and stamped copy.
18. Water Proofing (WPC) will be provided by Indigo.
19. Technical Specs to be maintained at site as below -
20. (A) SPAND content below or between 1% to 2%.
21. (B) pH adjustable between 9 - 10.
22. (C) Viscosity 140 to 150 sec (Hardness of water not more than 300 ppm) @ 0.1% dosage.
23. (D) Density range from 1.001 to 1.025.
24. Report - Please share daily basis polymer consumption report.
25. Consumption - You will provide guaranteed consumption of 0.400 gm/sqm. If polymer consumption exceeds 0.400 gm/sqm, you will have to bear extra consumption cost.
26. You will provide full-time technical staff on our site for a month (approx. cost will be ₹10,000/month).
27. Unloading - By Indigo Scope.
28. Weight Tolerance - 0.5% (+/-).
29. All manpower & support for fixing and removing of concrete pipeline to be done by you.
30. All work will be completed within 15 days as per site requirements.
31. The supply to be done in a continuous manner.
32. All raw material like Cement OPC, Aggregate, Sand, Admixture will be of approved quality by us & our client and as per approved Mix Design. Royalty paid challan copies to be provided for compliance record keeping.`);

    useEffect(() => {
        if (!show || !Array.isArray(items?.items) || items.items.length === 0) {
            setItemList([]);
            return;
        }

        const updatedItems = items.items;
        setItemList(updatedItems);
        setSelectedItems({});
        setSuppliers([]);
        fetchSuppliers();
    }, [show, items?.items]);

    const fetchSuppliers = async () => {
        try {
            const res = await POServices.activeSuppliers();
            setSuppliers(res?.data || []);
        } catch (err) {
            console.error("Failed to fetch suppliers", err);
        }
    };

    const handleCheckboxChange = (index) => {
        const prevItem = selectedItems[index] || {};
        const item = itemList[index];
        const isChecked = !prevItem.selected;

        setSelectedItems(prev => ({
            ...prev,
            [index]: {
                selected: isChecked,
                foc: false,
                rate: isChecked ? prevItem.rate || '' : '',
                supplier: isChecked ? prevItem.supplier || '' : '',
                cgst: isChecked ? prevItem.cgst || '' : '',
                sgst: isChecked ? prevItem.sgst || '' : '',
                igst: isChecked ? prevItem.igst || '' : '',
                description: isChecked
                    ? prevItem.description || item?.masterlist?.description || ''
                    : prevItem.description || item?.masterlist?.description || '',
                lockCGST: false,
                lockSGST: false,
                lockIGST: false,
                invalid: false
            }
        }));
    };

    const handleFOCChange = (index) => {
        setSelectedItems(prev => {
            const currentItem = prev[index] || {};
            const isFOC = !currentItem.foc;

            return {
                ...prev,
                [index]: {
                    ...currentItem,
                    foc: isFOC,
                    rate: isFOC ? 0 : currentItem.rate || '',
                    cgst: isFOC ? 0 : currentItem.cgst || '',
                    sgst: isFOC ? 0 : currentItem.sgst || '',
                    igst: isFOC ? 0 : currentItem.igst || '',
                    lockCGST: isFOC,
                    lockSGST: isFOC,
                    lockIGST: isFOC,
                }
            };
        });
    };

    const handleRateInput = (index, value) => {
        setSelectedItems(prev => ({
            ...prev,
            [index]: {
                ...(prev[index] || {}),
                rate: value,
                invalid: false
            }
        }));
    };

    const handleTaxInput = (index, field, value) => {
        const parsedValue = parseFloat(value) || 0;

        setSelectedItems(prev => {
            const currentItem = prev[index] || {};

            let updated = {
                ...currentItem,
                [field]: parsedValue,
                lockCGST: false,
                lockSGST: false,
                lockIGST: false,
            };

            if (field === 'cgst') {
                updated = {
                    ...updated,
                    cgst: parsedValue,
                    sgst: parsedValue,
                    igst: 0,
                    lockSGST: true,
                    lockIGST: true,
                };
            } else if (field === 'igst') {
                updated = {
                    ...updated,
                    igst: parsedValue,
                    cgst: 0,
                    sgst: 0,
                    lockCGST: true,
                    lockSGST: true,
                };
            }

            return {
                ...prev,
                [index]: updated
            };
        });
    };

    const handleSupplierChange = (index, supplierId) => {
        setSelectedItems(prev => ({
            ...prev,
            [index]: {
                ...(prev[index] || {}),
                supplier: supplierId,
                invalid: false,
            }
        }));

        if (selectedSupplier == null) setSelectedSupplier(supplierId);
    };

    const handleRateBlur = (index) => {
        setSelectedItems(prev => {
            const current = prev[index] || {};
            const rateNum = parseFloat(current.rate);

            return {
                ...prev,
                [index]: {
                    ...current,
                    rate: !isNaN(rateNum) && rateNum > 0 ? rateNum.toFixed(2) : '',
                    invalid: isNaN(rateNum) || rateNum <= 0
                }
            };
        });
    };

    const handleSubmit = async () => {
        const repairOrderId =
            items?.items?.[0]?.repairOrder?._id ||
            items?.items?.[0]?.repairOrder;

        if (!repairOrderId) {
            Swal.fire({
                icon: "warning",
                title: "Missing Repair Order",
                text: "Repair order details are missing.",
            });
            return;
        }

        if (!selectedSupplier) {
            Swal.fire({
                icon: "warning",
                title: "Supplier Required",
                text: "Please select a supplier.",
            });
            return;
        }

        setLoading(true); // ✅ START LOADING

        try {
            const cleanedItems = [];
            let hasInvalid = false;

            for (const [index, value] of Object.entries(selectedItems)) {
                if (!value.selected) continue;

                const item = itemList[index];

                const rate = Number(value.rate);
                const cgst = Number(value.cgst || 0);
                const sgst = Number(value.sgst || 0);
                const igst = Number(value.igst || 0);

                // ✅ Description validation
                if (!value.description || value.description.trim() === "") {
                    hasInvalid = true;
                    continue;
                }

                // ✅ Rate validation (allows 0 for FOC)
                if (!item || isNaN(rate) || rate < 0) {
                    hasInvalid = true;
                    continue;
                }

                // ✅ GST validation
                if ((cgst > 0 || sgst > 0) && igst > 0) {
                    hasInvalid = true;
                    continue;
                }

                cleanedItems.push({
                    repairItemId: item._id,
                    partNo: item.masterlist?.partNo,
                    description: value.description?.trim() || item.masterlist?.description || "",
                    unit: item.masterlist?.unit?.name || "",
                    fromUnit: item.masterlist?.unit?._id || null,
                    conversionValue: item.conversionValue || null,

                    qtyRequired: item.qtyRequired,
                    approveQty: item.approveQty,

                    rate,
                    cgst,
                    sgst,
                    igst,
                });
            }

            if (!cleanedItems.length || hasInvalid) {
                setLoading(false);
                Swal.fire({
                    icon: "warning",
                    title: "Invalid Data",
                    text: "Please fill all required fields correctly.",
                });
                return;
            }

            const payload = {
                repairOrder: repairOrderId,
                supplier: selectedSupplier,
                poType: cleanedItems.some((i) => i.rate === 0)
                    ? "FOC PO"
                    : "Normal",
                subject,
                reference,
                termCondition: termConditionText
                    .split("\n")
                    .map((t) => t.trim())
                    .filter(Boolean),
                items: cleanedItems,
            };

            await RepairPoServices.CreateRepairOrder(payload);

            Swal.fire({
                icon: "success",
                title: "Repair PO Created",
                text: `${cleanedItems.length} item(s) added successfully.`,
                timer: 2000,
                showConfirmButton: false,
            });

            test();
            handleClose();

        } catch (error) {
            console.error("Repair PO Error:", error);

            Swal.fire({
                icon: "error",
                title: "Failed",
                text:
                    error?.response?.data?.message ||
                    "Something went wrong!",
            });

        } finally {
            setLoading(false); // ✅ ALWAYS STOP LOADING
        }
    };


    const selectedCount = Object.values(selectedItems).reduce(
        (count, item) => (item.selected ? count + 1 : count),
        0
    );

    let totalBaseAmount = 0;
    let totalCGSTAmount = 0;
    let totalSGSTAmount = 0;
    let totalIGSTAmount = 0;

    for (const [index, item] of Object.entries(selectedItems)) {
        if (!item.selected || !item.rate || !itemList[index]?.approveQty) continue;

        const rate = parseFloat(item.rate) || 0;
        const qty = parseFloat(itemList[index].approveQty) || 0;
        const base = rate * qty;

        const cgst = base * ((parseFloat(item.cgst) || 0) / 100);
        const sgst = base * ((parseFloat(item.sgst) || 0) / 100);
        const igst = base * ((parseFloat(item.igst) || 0) / 100);

        totalBaseAmount += base;
        totalCGSTAmount += cgst;
        totalSGSTAmount += sgst;
        totalIGSTAmount += igst;
    }

    const calculatedTotal = (
        totalBaseAmount +
        totalCGSTAmount +
        totalSGSTAmount +
        totalIGSTAmount
    ).toFixed(2);

    return (
        <Modal className="fade" show={show} onHide={handleClose} enforceFocus={false} fullscreen>

            <Modal.Header closeButton>
                <Modal.Title><i className="fas fa-edit"></i> Items Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container fluid>
                    <Row className="mb-4 p-3 rounded border bg-white shadow-sm">
                        <Col xs={12} className="text-center mb-3">
                            <h5 className="text-primary fw-bold">
                                <i className="fas fa-map-marker-alt me-2"></i>STORE & REQUEST DETAILS
                            </h5>
                        </Col>
                        <Col xs={12} md={6}><div className="border p-3 bg-primary rounded mb-1 text-center text-capitalize"><strong className='text-dark'>Store Name</strong><div className='text-dark'>{items?.store || 'N/A'}</div></div></Col>
                        <Col xs={12} md={6}>
                            <div className="border p-3 bg-primary rounded mb-1 text-center text-capitalize">
                                <strong className='text-dark'>Request No.</strong>
                                <div className='text-dark'> {items?.repairOrderNo || 'N/A'}</div>
                            </div>
                        </Col>
                        <Col xs={12} md={4}>
                            <div className="border p-3 bg-primary rounded mb-1 text-center text-capitalize">
                                <strong className='text-dark'>Street</strong>
                                <div className='text-dark'>{items?.storeAddress?.street || 'N/A'}</div>
                            </div>
                        </Col>
                        <Col xs={12} md={4}>
                            <div className="border p-3 bg-primary rounded mb-1 text-center text-capitalize">
                                <strong className='text-dark'>City</strong>
                                <div className='text-dark'>{items?.storeAddress?.city || 'N/A'}</div>
                            </div>
                        </Col>
                        <Col xs={12} md={4}>
                            <div className="border p-3 bg-primary rounded mb-1 text-center text-capitalize">
                                <strong className='text-dark'>State</strong>
                                <div className='text-dark'>{items?.storeAddress?.state || 'N/A'}</div>
                            </div>
                        </Col>
                        <Col xs={12} md={4}>
                            <div className="border p-3 bg-primary rounded mb-1 text-center text-capitalize">
                                <strong className='text-dark'>Pincode</strong>
                                <div className='text-dark'>{items?.storeAddress?.pincode || 'N/A'}</div>
                            </div>
                        </Col>
                        <Col xs={12} md={4}>
                            <div className="border p-3 bg-primary rounded mb-1 text-center text-capitalize">
                                <strong className='text-dark'>Country</strong>
                                <div className='text-dark'>{items?.storeAddress?.country || 'N/A'}</div>
                            </div>
                        </Col>

                        <Col xs={12} md={4}>
                            <div className="border p-3 bg-primary rounded mb-1 text-center text-capitalize">
                                <strong className='text-dark'>Total Items</strong>
                                <div className='text-dark'>{items?.itemCount || 0}</div>
                            </div>
                        </Col>

                    </Row>

                    <Row>
                        <Col md="12">
                            <div className="table-responsive" style={{ overflowX: 'auto' }}>
                                <table className="table table-bordered table-striped" style={{ minWidth: '1400px' }}>

                                    <thead className="table-light">
                                        <tr>
                                            <th style={{ minWidth: '30px' }}>S.No</th>
                                            <th style={{ minWidth: '30px' }}>Inv Part No</th>
                                            <th style={{ minWidth: '150px' }}>Inv Description</th>
                                            <th style={{ minWidth: '30px' }}>Repair Part No</th>
                                            <th style={{ minWidth: '150px' }}>Repair Description</th>
                                            <th style={{ minWidth: '30px' }}>Unit</th>
                                            <th style={{ minWidth: '120px' }}>Approved Qty</th>
                                            <th style={{ minWidth: '80px' }}>Select</th>
                                            <th style={{ minWidth: '80px' }}>FOC</th>
                                            <th style={{ minWidth: '150px' }}>Rate</th>
                                            <th style={{ minWidth: '100px' }}>CGST</th>
                                            <th style={{ minWidth: '100px' }}>SGST</th>
                                            <th style={{ minWidth: '100px' }}>IGST</th>
                                            <th style={{ minWidth: '200px' }}>Supplier</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {itemList.length > 0 ? itemList.map((item, index) => {

                                            const repair = item?.masterlist;
                                            const selected = selectedItems[index]?.selected;
                                            const invalid = selectedItems[index]?.invalid;

                                            return (
                                                <tr key={index} className={invalid ? 'table-danger' : ''}>
                                                    <td>{index + 1}</td>

                                                    {/* Inventory Part + Description (Flat Fields) */}
                                                    <td>{items?.inventoryPartNo || '-'}</td>
                                                    <td>{items?.inventoryDescription || '-'}</td>


                                                    {/* Repair Masterlist */}
                                                    <td>{repair?.partNo || '-'}</td>
                                                    <td>
                                                        <Form.Control
                                                            type="text"
                                                            disabled={!selected}   // ✅ STRICT CONTROL
                                                            placeholder={selected ? "Edit repair description" : "Select row to edit"}
                                                            value={
                                                                selectedItems[index]?.description ??
                                                                item?.masterlist?.description ??
                                                                ''
                                                            }
                                                            onChange={(e) => {
                                                                if (!selected) return; // ✅ safety guard

                                                                setSelectedItems(prev => ({
                                                                    ...prev,
                                                                    [index]: {
                                                                        ...(prev[index] || {}),
                                                                        description: e.target.value
                                                                    }
                                                                }));
                                                            }}
                                                        />
                                                    </td>

                                                    {/* Unit (prefer repair unit; fallback '-') */}
                                                    <td>{repair?.unit?.name || '-'}</td>

                                                    {/* Approved Qty */}
                                                    <td>

                                                        {item.approveQty}

                                                    </td>

                                                    {/* Select */}
                                                    <td>
                                                        <Form.Check
                                                            type="checkbox"
                                                            onChange={() => handleCheckboxChange(index)}
                                                            checked={selected}
                                                        />
                                                    </td>

                                                    {/* FOC */}
                                                    <td>
                                                        <Form.Check
                                                            type="checkbox"
                                                            disabled={!selected}
                                                            onChange={() => handleFOCChange(index)}
                                                            checked={selectedItems[index]?.foc || false}
                                                        />
                                                    </td>

                                                    {/* Rate */}
                                                    <td>
                                                        <Form.Control
                                                            type="number"
                                                            disabled={!selected || selectedItems[index]?.foc}
                                                            placeholder="Enter rate"
                                                            value={selectedItems[index]?.rate || ''}
                                                            onChange={(e) => handleRateInput(index, e.target.value)}
                                                            onBlur={() => handleRateBlur(index)}
                                                        />
                                                    </td>

                                                    {/* CGST */}
                                                    <td>
                                                        <Form.Control
                                                            type="number"
                                                            disabled={selectedItems[index]?.foc}
                                                            placeholder="CGST %"
                                                            value={selectedItems[index]?.cgst || ''}
                                                            onChange={(e) => handleTaxInput(index, 'cgst', e.target.value)}
                                                            readOnly={selectedItems[index]?.lockCGST}
                                                        />
                                                    </td>

                                                    {/* SGST */}
                                                    <td>
                                                        <Form.Control
                                                            type="number"
                                                            disabled={selectedItems[index]?.foc}
                                                            placeholder="SGST %"
                                                            value={selectedItems[index]?.sgst || ''}
                                                            onChange={(e) => handleTaxInput(index, 'sgst', e.target.value)}
                                                            readOnly={selectedItems[index]?.lockSGST}
                                                        />
                                                    </td>

                                                    {/* IGST */}
                                                    <td>
                                                        <Form.Control
                                                            type="number"
                                                            disabled={selectedItems[index]?.foc}
                                                            placeholder="IGST %"
                                                            value={selectedItems[index]?.igst || ''}
                                                            onChange={(e) => handleTaxInput(index, 'igst', e.target.value)}
                                                            readOnly={selectedItems[index]?.lockIGST}
                                                        />
                                                    </td>

                                                    {/* Supplier */}
                                                    <td>
                                                        <Form.Select
                                                            disabled={!!selectedSupplier}
                                                            value={selectedItems[index]?.supplier || selectedSupplier || ""}
                                                            onChange={(e) => handleSupplierChange(index, e.target.value)}
                                                        >
                                                            <option value="">-- Select Supplier --</option>
                                                            {suppliers.map(s => (
                                                                <option key={s._id} value={s._id}>
                                                                    {s.name}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                    </td>
                                                </tr>
                                            );
                                        }) : (
                                            <tr>
                                                <td colSpan="14" className="text-center text-muted">
                                                    No items available.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>


                                </table>
                            </div>
                        </Col>
                    </Row>

                    <Row className="mb-4 mt-3 pb-4 pt-3 rounded border bg-light shadow-sm">
                        <Col xs={12} className="text-center mb-3">
                            <h5 className="fw-bold"><i className="fas fa-info-circle me-2"></i>Additional PO Information</h5>
                        </Col>

                        <Col md={12}>
                            <Form.Group controlId="subject">
                                <Form.Label>Subject</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter subject"
                                    value={subject}
                                    onChange={(e) => setSubject(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={12}>
                            <Form.Group controlId="reference">
                                <Form.Label>Reference</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    placeholder="Enter reference"
                                    value={reference}
                                    onChange={(e) => setReference(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={12} className="mt-3">
                            <Form.Group controlId="termCondition">
                                <Form.Label className='fw-bold'>Terms & Conditions (one per line)</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    placeholder="Enter terms and conditions, one per line"
                                    value={termConditionText}
                                    onChange={(e) => setTermConditionText(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {selectedCount > 0 && (
                        <Row className="mt-3">
                            <Col className="text-end text-success fw-bold">
                                Total Selected Items: {selectedCount}<br />
                                Base Amount: ₹{totalBaseAmount.toFixed(2)}<br />
                                CGST: ₹{totalCGSTAmount.toFixed(2)} | SGST: ₹{totalSGSTAmount.toFixed(2)} | IGST: ₹{totalIGSTAmount.toFixed(2)}<br />
                                <span className="text-primary">Estimated Total Amount: ₹{calculatedTotal}</span>
                            </Col>
                        </Row>
                    )}
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Close</Button>
                <Button
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={selectedCount === 0 || loading}
                >
                    {loading ? "Processing..." : "Submit"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default React.memo(PoMakingModal);
